import { styled } from '@mui/material/styles';

export const StyledContainer = styled('div')`
    margin: 2rem 0;
`;
